import React from 'react';
import ShoppingCart from '@mui/icons-material/ShoppingCart'
import AppColors from '../assets/colors';
import GreenSubmitButton  from'./greenSubmitButton'

const AddToCartButton = ({ disabled, onClick })=> {

  
  return(
    <GreenSubmitButton
      disabled={disabled} 
      onClick={onClick}
      width= {'60%'}
      startIcon={<ShoppingCart />}
    >
   
    </GreenSubmitButton>

  )
}

export default AddToCartButton;
